<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.questions', 2),
                        href: meta.links.questions_index,
                    },
                    {
                        name: $t('messages.batch_update_questions'),
                        href: null,
                    },
                ]"
            />
        </template>
        <div>{{ $tc('messages.columns', 2) }}:</div>
        <div>
            {{ ['id', $t('messages.type'), $t('messages.title'), $t('messages.description')].join(', ') }}
        </div>
        <div class="mt-5">{{ $t('messages.will_update_these_fields') }}:</div>
        <div>
            {{ [$t('messages.title'), $t('messages.description')].join(', ') }}
        </div>
        <div>
            <form :action="meta.links.update" @submit.prevent="submit">
                <div class="mt-5">
                    <div class="mt-1">
                        <FormLabel :value="$tc('messages.files', 1)" for="file" />
                        <input
                            id="file"
                            @input="form.csv = $event.target.files[0]"
                            name="file"
                            type="file"
                            accept=".csv"
                            class="mt-1 w-full"
                        />
                        <FormError :value="form.errors.csv" class="mt-2" />
                    </div>
                </div>
                <div class="flex justify-end mt-5">
                    <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
                </div>
            </form>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import FormLabel from '../../../../../components/Forms/FormLabel.vue';
import FormError from '../../../../../components/Forms/FormError.vue';
import SubmitFormButton from '../../../Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        FormError,
        FormLabel,
        PanelPage,
    },
    layout: Layout,
    name: 'Edit',
    props: ['meta'],
    data() {
        return {
            form: this.$inertia.form({
                _method: 'patch',
                csv: null,
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(this.meta.links.update);
        },
    },
};
</script>
